import clsx from 'clsx';
import { IconSource } from 'types/icons';
import { variationName } from 'utilities/css';

import styles from './Icon.module.scss';

type Color = 'none' | 'default' | 'critical' | 'success' | 'inherit';

interface IconProps {
  source: IconSource;
  color?: Color;
}

export function Icon({ source, color = 'default' }: IconProps) {
  const className = clsx(
    styles.Icon,
    color && styles[variationName('color', color)],
  );
  const SourceComponent = source;

  const iconMarkup = (
    <SourceComponent
      className={styles.Svg}
      focusable="false"
      aria-hidden="true"
    />
  );

  return <span className={className}>{iconMarkup}</span>;
}
